<section>
  <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row"
       style="color:blue;" *ngIf="shouldShowPaintDisclaimerMsg">
    {{paintDisclaimerMsg}}
  </div>
  <!-- START DIRECT ITEM ENTRY -->
  <div *ngIf="showQuickAdd" class="d-flex flex-column my-3">
    <app-quick-add-item (itemAdded)="itemAdded($event)" [mode]="'add-to-quote'" [quoteCommonId]="selectedQuoteHeader?.quoteCommonId"></app-quick-add-item>
  </div>
  <!-- END DIRECT ITEM ENTRY -->
  <div *ngIf="this.quoteService.selectedQuoteHeader.isLocked" class="d-flex flex-column my-3">
    <h6 style="text-align: center; color:red">{{this.QuoteLockDialog.loadingMessage}}</h6>
  </div>
</section>

<section>
  <!-- START QUOTEITEM GRID -->
  <form novalidate #myForm="ngForm" class="cart-grid-wrapper">
    <!--[kendoGridInCellEditing]="createEditFormGroup"-->
    <!--[removeConfirmation]="removeConfirmation"-->
    <kendo-grid [data]="quoteItemsView"
                class="custom-footer"
                [rowSelected]="isRowSelected"
                [selectable]="true"
                [groupable]="false"
                [sortable]="false"
                [navigable]="true"
                [filterable]="false"
                [reorderable]="true"
                [resizable]="true"
                [sort]="kdQuoteItemGridstate.sort"
                [pageable]=pageable
                [pageSize]="kdQuoteItemGridstate.take"
                [skip]="kdQuoteItemGridstate.skip"
                [columnMenu]="false"
                (sort)="kdQuoteItemGridSortChange($event)"
                (pageChange)="kdQuoteItemGridPageChange($event)"
                (dataStateChange)="kdQuoteItemDataStateChange($event)"
                [filter]="kdQuoteItemGridstate.filter"
                [loading]="quoteItemGridLoading">
      <ng-template kendoGridToolbarTemplate>
        <div class="d-flex align-items-center justify-content-between">
          <button kendoButton [disabled]="this.quoteService.selectedQuoteHeader.isLocked" [icon]="'plus'" class="btn" [selected]="true" (click)="toggleShowQuickAdd()">
            {{quoteDetailTxt.quickAddLbl?quoteDetailTxt.quickAddLbl:quickAddQuote.quickAddLbl}}
          </button>

          <!--<div style="width: 250px;">-->
          <!-- empty div so justify-content-between puts the Add to Cart button in the center of the toolbar. -->
          <!--</div>-->


        </div>
        <div class="d-flex align-items-center justify-content-between pwa-btn">
          <button kendoButton [icon]="'shopping-cart'" class="btn btn-success"
                  [disabled]="isQuoteToCartLoading || isHaveErrorInGrid"
                  (click)="addQuoteToCart()">
            {{quoteDetailTxt.addQuoteToCartLbl?quoteDetailTxt.addQuoteToCartLbl:quickAddQuote.addQuoteToCartLbl}} <kendo-loader *ngIf="isQuoteToCartLoading" style="color:blue"></kendo-loader>
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-between pwa-btn">
          <button (click)="openDeleteQuoteConfirmationBox()" class="btn btn-success" kendoButton [icon]="'delete'"
                  [disabled]="deleteQuoteInProgress">
            {{quoteDetailTxt.emptyQuoteLbl?quoteDetailTxt.emptyQuoteLbl:quickAddQuote.emptyQuoteLbl}} <kendo-loader *ngIf="deleteQuoteInProgress" style="color:blue"></kendo-loader>
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-between pwa-btn">
          <button kendoButton [icon]="'shopping-cart'" class="m-3 btn btn-success"
                  [disabled]="isQuoteToCartLoading || isEmptyPaintInGrid || isHaveErrorInGrid"
                  (click)="showExpressCheckoutModal()">
            {{quoteDetailTxt.expressCheckoutBtnText?quoteDetailTxt.expressCheckoutBtnText:'Express Checkout'}}
            <kendo-loader *ngIf="isQuoteToCartLoading" style="color:blue"></kendo-loader>
          </button>
        </div>
      </ng-template>

      <kendo-grid-column media="(max-width: 1024px)" title="Quote Items">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="row">
            <div style="width:100%">
              <div class="row">
                <div class="col-5 paddingZero">
                  <div class="row">
                    <div class="col-12 paddingZero">
                      <!--<img src="http://noatdc-dweb911:8084/assets/itemCatalog/013606_S.gif" />-->
                      <!--<img src="{{imageURL}}{{dataItem.actualPicture}}" alt="{{dataItem.itemNumber}}" />-->
                      <span style="display:none;" *ngIf="!dataItem?.funcCall">{{showImagePWA(dataItem)}}</span>
                      <img class="infoBoxImg a" imageLoader src='../../../assets/images/loading.svg' *ngIf="!dataItem?.thumbnail" [alt]="">
                      <span *ngIf="dataItem?.thumbnail">
                        <img class="cartImage" [src]='dataItem?.thumbnail' alt="{{dataItem.itemNumber}}">
                        <button class="k-button k-grid-edi-command copy-btn" (click)="navigateToCopyConfigProduct(dataItem)" *ngIf="dataItem.itemType===2">
                          <span class="k-icon k-i-copy">
                          </span>
                        </button>
                        <button class="k-button k-grid-edi-command edit-btn" (click)="navigateToEditConfigProduct(dataItem) " *ngIf="dataItem.itemType===2">
                          <span class="k-icon k-i-edit">
                          </span>
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 cartItemNumber">
                      {{dataItem.itemNumber}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-3 col-md-3 qtyPwa">
                      {{quoteDetailTxt.quantityLbl?quoteDetailTxt.quantityLbl:quickAddQuote.quantityLbl}}:
                      <!--<kendo-numerictextbox *ngIf="dataItem.itemType===1" [value]="dataItem.quantity" [format]="'n'" [decimals]="0" [min]="1"
                    [max]="999" (valueChange)="handleQuoteItemQtyChanged($event,dataItem)"
                    (blur)="handleQuoteItemQtyUpdate($event,dataItem)" [autoCorrect]="true" class="quantityCls">
                   </kendo-numerictextbox>-->
                      <span *ngIf="dataItem?.itemType>1">
                        {{dataItem.quantity}}
                      </span>

                    </div>
                    <div class="col-sm-9 col-md-9 paddingZero" *ngIf="dataItem?.itemType===1">
                      <app-numeric-text-box [numericData]="dataItem.quantity"
                                            [maxQty]=999 [isUpdateButton]="true" (event)="change(dataItem,$event)">
                      </app-numeric-text-box>
                    </div>
                  </div>
                </div>
                <div class="col-7 paddingZero">
                  <!--<div class="row">

              </div>-->
                  <div class="row">
                    <div class="col-9 item-description">
                      {{dataItem.itemDescription}}
                    </div>
                    <div class="col-3 paddingZero textRight">
                      <button class="k-button k-grid-shop-command k-icon actionBtnCls " kendoButton [icon]="'shopping-cart'"
                              (click)="addQuoteItemToCart(dataItem)"
                              [disabled]="dataItem.updateInProgress || dataItem.doesHaveError">
                      </button>
                      <button class="k-button k-grid-remove-command actionBtnCls" [disabled]="dataItem.updateInProgress" (click)="removeConfirmation(dataItem);selectedGridRow(dataItem) ">
                        <span class="k-icon k-i-trash">
                        </span>
                      </button>
                      <kendo-loader *ngIf="dataItem.updateInProgress" style="color:blue"></kendo-loader>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-3 paddingLeftZero" style="padding-top:7px; text-align:left">
                      {{quoteDetailTxt.finishLbl?quoteDetailTxt.finishLbl:quickAddQuote.finishLbl}}:
                    </div>
                    <div class="col-9 paddingRightZero ">
                      <kendo-dropdownlist [data]="dataItem.availableFinishes"
                                          (valueChange)="handleQuoteItemFinishChange($event,dataItem)" [textField]="'name'"
                                          [valueField]="'value'"
                                          [value]="{value:dataItem.finishValue,name:dataItem.finish}" class="finishStyleCls"
                                          [ngClass]="{'borderRed':(dataItem?.doesHaveError == true)}"
                                          *ngIf="dataItem?.itemType===1 && dataItem?.availableFinishes?.length>0">
                      </kendo-dropdownlist>
                      <!--<input type="text" />-->
                    </div>
                  </div>

                  <div class="row" *ngIf="dataItem.finishValue==='22'">
                    <div class="col-3 paddingLeftZero" style="padding-top:7px; text-align:left">
                      {{quoteDetailTxt.paintLbl?quoteDetailTxt.paintLbl:quickAddQuote.paintLbl}}:
                    </div>
                    <div class="col-9 paddingRightZero ">
                      <kendo-dropdownlist [data]="dataItem.paintValue"
                                          [value]="{value:dataItem.paint,name:dataItem.paintName}"
                                          [textField]="'name'"
                                          [valueField]="'value'"
                                          (valueChange)="handlePaintChange($event,dataItem)"
                                          [popupSettings]="{popupClass:'freight-popup'}"
                                          [filterable]="true"
                                          (filterChange)="handlePaintFilter($event,dataItem)"
                                          (open)="handlePaintFilter(null,dataItem)"
                                          class="finishStyleCls"
                                          [ngClass]="{'borderRed':dataItem?.isEmptyPaint || dataItem?.doesHaveError == true}"></kendo-dropdownlist>
                    </div>
                  </div>
                  <div class="row" *ngIf="dataItem.itemType===1">
                    <div class="col-3 paddingLeftZero" style="padding-top:7px; text-align:left">
                      {{quoteDetailTxt.extrusionLbl?quoteDetailTxt.extrusionLbl:quickAddQuote.extrusionLbl}}:
                    </div>
                    <div class="col-9 paddingRightZero">
                      <kendo-dropdownlist [data]="dataItem.currentSizes" [textField]="'value'" [valueField]="'value'"
                                          [value]="{value:dataItem.size}" (valueChange)="handleQuoteItemSizeChange($event,dataItem)"
                                          *ngIf="dataItem?.itemType===1 && dataItem?.currentSizes?.length>0" class="finishStyleCls"></kendo-dropdownlist>
                      <span *ngIf="dataItem.itemType===1 && dataItem?.currentSizes?.length<1">
                        {{dataItem?.size}}
                      </span>
                    </div>
                  </div>

                  <div class="row ">
                    <div class="col-3 paddingLeftZero cartUnit" style="padding-top:7px; text-align:left">
                      {{quoteDetailTxt.unitLbl?quoteDetailTxt.unitLbl:quickAddQuote.unitLbl}}:
                    </div>
                    <div class="col-9 paddingZero cartUnit">
                      EA
                      <!--Need to bind dynamically-->

                    </div>

                  </div>
                  <div class="row">
                    <div class="col-12 paddingLeftZero" id="extendedPrice">
                      <kendo-expansionpanel>
                        <ng-template kendoExpansionPanelTitleDirective>
                          <div class="header-content ">
                            <span>Price: {{dataItem.extendedPrice | currency: dataItem.currencySymbol}}</span>
                          </div>
                        </ng-template>
                        <div style="font-size:10px;">{{quoteDetailTxt.listPriceLbl?quoteDetailTxt.listPriceLbl:quickAddQuote.listPriceLbl}} - {{dataItem.listPrice | currency: dataItem.currencySymbol}}</div>
                        <div style="font-size:10px;">
                          {{quoteDetailTxt.unitPriceLbl?quoteDetailTxt.unitPriceLbl:quickAddQuote.unitPriceLbl}} -
                          {{dataItem.unitPrice | currency: dataItem.currencySymbol}}
                        </div>
                        <div style="font-size:10px;">
                          {{quoteDetailTxt.multiplierLbl?quoteDetailTxt.multiplierLbl:quickAddQuote.multiplierLbl}} -
                          {{dataItem?.cmp | number:'1.3-3'}}
                        </div>
                      </kendo-expansionpanel>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <div class="row" id="customer-footer">
            <!-- Left note -->
            <div class="col-4">
              <p>* KawneerDirect quotes and orders currently not     eligible to be processed as BABAA certified.</p>
            </div>
            <!-- Total -->
            <div class="col-8 totalPrice textRight">
              {{quoteItemsTotal | currency}} - {{quoteDetailTxt.totalPriceLbl?quoteDetailTxt.totalPriceLbl:quickAddQuote.totalPriceLbl}}
            </div>
          </div>
          <div class="row" *ngIf="showMinOrderFee">
            <div class="col-12 text-right">
              <div class="quote-minfee-inline-mobile">
                {{ minFeeDisplayLine }}
              </div>
            </div>
          </div>
          <!-- Gray info list -->
          <div class="post-indicator-text-sm">
            <div>
              <div>
                {{quoteDetailTxt.gridTextLbl1?quoteDetailTxt.gridTextLbl1:quickAddQuote.gridTextLbl1}}
              </div>
              <div>
                {{quoteDetailTxt.gridTextLbl2?quoteDetailTxt.gridTextLbl2:quickAddQuote.gridTextLbl2}}
              </div>
              <div>
                {{quoteDetailTxt.gridTextLbl3?quoteDetailTxt.gridTextLbl3:quickAddQuote.gridTextLbl3}}
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>




      <kendo-grid-column media="(min-width: 1050px)" title="{{quoteDetailTxt.lineLbl?quoteDetailTxt.lineLbl:quickAddQuote.lineLbl}}" [width]="60" [resizable]="false" [sortable]="true" [groupable]="false"
                         [editable]="false" [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">

        <ng-template kendoGridCellTemplate class="d-flex justify-content-center" let-rowIndex="rowIndex">
          <strong>{{rowIndex + 1}}</strong>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(min-width: 1050px)" [filterable]="false" [sortable]="false" field="quantity" title="{{quoteDetailTxt.quantityLbl?quoteDetailTxt.quantityLbl:quickAddQuote.quantityLbl}}"
                         [width]="80" [minResizableWidth]="20">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem?.itemType===1">
            <kendo-numerictextbox [value]="dataItem.quantity" [spinners]="false" [format]="'n'"
                                  [decimals]="0" [min]="1" (valueChange)="handleQuoteItemQtyChanged($event,dataItem)"
                                  [disabled]="this.quoteService.selectedQuoteHeader.isLocked"
                                  (blur)="handleQuoteItemQtyUpdate(dataItem)" [autoCorrect]="true" class="qtyTxtCls">
            </kendo-numerictextbox>
          </span>
          <span *ngIf="dataItem?.itemType>1">
            {{ dataItem?.quantity}}
          </span>
        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <div>
            <ul class="messageBoxCustom">
              <li>{{quoteDetailTxt.messageTxtLbl1?quoteDetailTxt.messageTxtLbl1:quickAddQuote.messageTxtLbl1}}</li>
              <li>{{quoteDetailTxt.messageTxtLbl6?quoteDetailTxt.messageTxtLbl6:quickAddQuote.messageTxtLbl6}}</li>
              <li>{{quoteDetailTxt.messageTxtLbl2?quoteDetailTxt.messageTxtLbl2:quickAddQuote.messageTxtLbl2}}</li>
              <li>{{quoteDetailTxt.infoLbl?quoteDetailTxt.infoLbl:quickAddQuote.infoLbl}}</li>
            </ul>

          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="unitOfMeasure" [minResizableWidth]="20" [width]="70" title="{{quoteDetailTxt.unitLbl?quoteDetailTxt.unitLbl:quickAddQuote.unitLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">

        <ng-template kendoGridCellTemplate let-dataItem>
          EA
          <!--Need to bind dynamically-->
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="itemNumber" [minResizableWidth]="70" [width]="120" title="{{quoteDetailTxt.itemLbl?quoteDetailTxt.itemLbl:quickAddQuote.itemLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-between align-items-center" [ngClass]="{'borderRed':(dataItem?.doesHaveError == true && dataItem.errorCheckType == 'ItemNumber')}">
            {{dataItem.itemNumber}}
            <button kendoButton *ngIf="enableEdit && dataItem?.doesHaveError == false" [icon]="'info'" [look]="'flat'" (click)="showImageModal(dataItem,$event)">
            </button>
            <span title="{{quickAddQuote.invalidQuotetext}}:{{dataItem.errorMessage}}" *ngIf="dataItem?.doesHaveError == true" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoCls"
                  (click)="showImageModal(dataItem,$event)"
                  [ngClass]="{'iconRed':(dataItem?.doesHaveError == true && dataItem.errorCheckType == 'ItemNumber')}"></span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" field="availableFinish" title="{{quoteDetailTxt.finishLbl?quoteDetailTxt.finishLbl:quickAddQuote.finishLbl}}" [width]="200" [filterable]="false"
                         [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-dropdownlist [data]="dataItem.availableFinishes"
                              (valueChange)="handleQuoteItemFinishChange($event,dataItem)" [textField]="'name'"
                              [valueField]="'value'"
                              [value]="{value:dataItem.finishValue,name:dataItem.finish}"
                              [ngClass]="{'borderRed':(dataItem?.doesHaveError == true && dataItem.errorCheckType == 'Finish')}"
                              [ngStyle]="this.quoteService.selectedQuoteHeader.isLocked==true ? {'pointer-events': 'none','opacity': '0.6'} : {}"
                              [popupSettings]="{popupClass:'freight-popup'}"
                              *ngIf="dataItem?.itemType===1 && dataItem?.availableFinishes?.length>0">
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(min-width: 1050px)" field="paint" title="{{quoteDetailTxt.paintLbl?quoteDetailTxt.paintLbl:quickAddQuote.paintLbl}}" [editable]="false" [width]="200"
                     [filterable]="false" [sortable]="false">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <kendo-dropdownlist [data]="dataItem.paintValue"
                          [value]="{value:dataItem.paint,name:dataItem.paintName}"
                          [textField]="'name'"
                          [valueField]="'value'"
                          (valueChange)="handlePaintChange($event,dataItem)"
                          [filterable]="true"
                          (filterChange)="handlePaintFilter($event,dataItem)"
                          [ngStyle]="this.quoteService.selectedQuoteHeader.isLocked==true ? {'pointer-events': 'none','opacity': '0.6'} : {}"
                          [popupSettings]="{popupClass:'freight-popup'}"
                          (open)="handlePaintFilter(null,dataItem)"
                          *ngIf="dataItem.finishValue==='22'"
                          [ngClass]="{'borderRed':dataItem?.isEmptyPaint || (dataItem?.doesHaveError == true && dataItem.errorCheckType == 'Paint')}">

      </kendo-dropdownlist>
      </ng-template>

      </kendo-grid-column>

      <kendo-grid-column media="(min-width: 1050px)" field="availableFinishes" title="{{quoteDetailTxt.extrusionLbl?quoteDetailTxt.extrusionLbl:quickAddQuote.extrusionLbl}}" [editable]="enableEdit" [width]="100"
                         [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-dropdownlist [data]="dataItem.currentSizes" [textField]="'value'" [valueField]="'value'"
                              [ngStyle]="this.quoteService.selectedQuoteHeader.isLocked==true ? {'pointer-events': 'none','opacity': '0.6'} : {}"
                              [value]="{value:dataItem.size}" (valueChange)="handleQuoteItemSizeChange($event,dataItem)"
                              *ngIf="dataItem.itemType===1 && dataItem?.currentSizes?.length>0" class="extrusionDropCls"></kendo-dropdownlist>
          <!--<span   *ngIf="dataItem.itemType===1 && dataItem?.currentSizes?.length<1">
        {{dataItem?.size}}
      </span>-->
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="itemDescription" [minResizableWidth]="180" [width]="180"
                         title="{{quoteDetailTxt.itemDescriptionLbl?quoteDetailTxt.itemDescriptionLbl:quickAddQuote.itemDescriptionLbl}}" [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="listPrice" [minResizableWidth]="70" [width]="100" title="List Price"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.listPrice | currency: dataItem.currencySymbol}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="cmp" [minResizableWidth]="70" [width]="70" title="Multiplier {{quoteDetailTxt.quickAddLbl?quoteDetailTxt.quickAddLbl:quickAddQuote.quickAddLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>
            {{dataItem.cmp | number:'1.3-3'}}
          </span>
        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <h4 class="cartTotalInGrid">
            {{quoteItemsTotal | currency}} - {{quoteDetailTxt.totalPriceLbl?quoteDetailTxt.totalPriceLbl:quickAddQuote.totalPriceLbl}}
          </h4>
          <div *ngIf="showMinOrderFee" class="quote-minfee-inline-in-grid">
            {{ minFeeDisplayLine }}
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="unitPrice" [minResizableWidth]="70" [width]="80" title="{{quoteDetailTxt.unitPriceLbl?quoteDetailTxt.unitPriceLbl:quickAddQuote.unitPriceLbl}}"
                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.unitPrice | currency: dataItem.currencySymbol}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="extendedPrice" [minResizableWidth]="70" [width]="100"
                         title="{{quoteDetailTxt.extPriceLbl?quoteDetailTxt.extPriceLbl:quickAddQuote.extPriceLbl}}">
        <ng-template kendoGridCellTemplate let-dataItem>

          <!--{{(dataItem.listPrice * dataItem.multiplier * dataItem.quantity) | currency: dataItem.currencySymbol}}-->
          {{(dataItem?.extendedPrice) | currency: dataItem.currencySymbol}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column media="(min-width: 1050px)" [resizable]="false" [width]="120" title="{{quoteDetailTxt.actionLbl?quoteDetailTxt.actionLbl:quickAddQuote.actionLbl}}"
                                 [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                 [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
        <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem>
          <div class="action-container">
            <button class="k-button k-grid-remove-command"
                    (click)="addQuoteItemToCart(dataItem)"
                    [disabled]="this.quoteService.selectedQuoteHeader.isLocked || dataItem.updateInProgress || dataItem.isEmptyPaint || dataItem.doesHaveError">
              <span class="k-icon k-i-cart"></span>
            </button>
            <button class="k-button k-grid-remove-command trash"
                    [disabled]="this.quoteService.selectedQuoteHeader.isLocked || dataItem.updateInProgress"
                    (click)="removeConfirmation(dataItem);selectedGridRow(dataItem)">
              <span class="k-icon k-i-trash">
              </span>
            </button>
          </div>
          <kendo-loader *ngIf="dataItem.updateInProgress" style="color:blue"></kendo-loader>
        </ng-template>
      </kendo-grid-command-column>
      <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
        <kendo-pager-info></kendo-pager-info>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
        <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
      </ng-template>
    </kendo-grid>
  </form>
  <!-- END QUOTEITEM GRID -->
</section>
<section>
  <!-- PAGE PAGE BUTTOM CONTROLS -->
  <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
    <button (click)="openImportDialog()" class=" m-3 btn btn-success btn-import"
            [disabled]="this.quoteService.selectedQuoteHeader.isLocked || isQuoteToCartLoading || isEmptyPaintInGrid || isHaveErrorInGrid"
            kendoButton [icon]="'file-bac'">
      {{quoteDetailTxt.importLbl?quoteDetailTxt.importLbl:quickAddQuote.importLbl}}
    </button>
    <button (click)="openDeleteQuoteConfirmationBox()" class=" m-3 btn btn-success btn-import" kendoButton [icon]="'delete'"
            [disabled]="this.quoteService.selectedQuoteHeader.isLocked || deleteQuoteInProgress">
      {{quoteDetailTxt.emptyQuoteLbl?quoteDetailTxt.emptyQuoteLbl:quickAddQuote.emptyQuoteLbl}} <kendo-loader *ngIf="deleteQuoteInProgress" style="color:blue"></kendo-loader>
    </button>
    <button kendoButton [icon]="'shopping-cart'" class="m-3 btn btn-success btn-import"
            [disabled]="this.quoteService.selectedQuoteHeader.isLocked ||isQuoteToCartLoading || isEmptyPaintInGrid || isHaveErrorInGrid"
            (click)="addQuoteToCart()">
      {{quoteDetailTxt.addQuoteToCartLbl?quoteDetailTxt.addQuoteToCartLbl:quickAddQuote.addQuoteToCartLbl}} <kendo-loader *ngIf="isQuoteToCartLoading" style="color:blue"></kendo-loader>
    </button>
    <button kendoButton [icon]="'shopping-cart'" class="m-3 btn btn-success btn-import highlight-border"
            [disabled]="this.quoteService.selectedQuoteHeader.isLocked || isEmptyPaintInGrid || isHaveErrorInGrid"
            (click)="showExpressCheckoutModal()">
      Express Checkout<kendo-loader *ngIf="isQuoteToCartLoading" style="color:blue"></kendo-loader>
    </button>
    <!--|| isQuoteToCartLoing-->
    <button kendoButton [icon]="'copy'" class="m-3 btn btn-success"
            [disabled]="this.quoteService.selectedQuoteHeader.isLocked || copyQuoteDialog?.opened || isEmptyPaintInGrid || isHaveErrorInGrid"
            (click)="toggleCopyQuoteDialog()">
      {{quoteDetailTxt.copyQuoteLbl?quoteDetailTxt.copyQuoteLbl:quickAddQuote.copyQuoteLbl}}
      <!--<kendo-loader *ngIf="copyQuoteDialog?.opened" style="color:blue"></kendo-loader>-->
    </button>
    <button kendoButton [icon]="'plus'" class="m-3 btn btn-success"
            [disabled]="this.quoteService.selectedQuoteHeader.isLocked || isCreateNewRevisionLoading || isEmptyPaintInGrid || isHaveErrorInGrid"
            (click)="createNewRevision()">
      {{quoteDetailTxt.createNewRevisionLbl?quoteDetailTxt.createNewRevisionLbl:quickAddQuote.createNewRevisionLbl}} <kendo-loader *ngIf="isCreateNewRevisionLoading" style="color:blue"></kendo-loader>
    </button>
    <button kendoButton [icon]="'print'" class="m-3 btn btn-success"
            [disabled]="this.quoteService.selectedQuoteHeader.isLocked || isPrintMaterialProposalLoading || isEmptyPaintInGrid || isHaveErrorInGrid"
            (click)="printMaterialProposal()">
      {{quoteDetailTxt.printMaterialProposal?quoteDetailTxt.printMaterialProposal:quickAddQuote.printMaterialProposal}}
      <!--<kendo-loader *ngIf="isPrintMaterialProposalLoading" style="color:blue"></kendo-loader>-->
    </button>
  </div>


  <!-- END PAGE BUTTOM CONTROLS -->
</section>
<section>
  <!-- PAGE DIALOG POPUP-->
  <kendo-dialog title="Please confirm" *ngIf="showQuoteDeleteConfirmBox" (close)="confirmRemove(false)">
    <p style="margin: 30px; text-align: center;">
      {{quoteDetailTxt.deleteConfirmText1?quoteDetailTxt.deleteConfirmText1:quickAddQuote.deleteConfirmText1}}
      <b>{{quoteDetailTxt.itemNumLbl?quoteDetailTxt.itemNumLbl:quickAddQuote.itemNumLbl}}: {{ gridItemToRemove?.itemNumber }}?</b>
    </p>
    <kendo-dialog-actions>
      <button class='k-button' (click)="confirmRemove(false)">
        {{quoteDetailTxt.noLbl?quoteDetailTxt.noLbl:quickAddQuote.noLbl}}
      </button>
      <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
        {{quoteDetailTxt.yesLbl?quoteDetailTxt.yesLbl:quickAddQuote.yesLbl}}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <!-- END PAGE DIALOG POPUP -->
</section>
<section>
  <!--  DELETE QUOTE DIALOG POPUP-->
  <kendo-dialog title="{{quoteDetailTxt.pleaseConfirmLbl?quoteDetailTxt.pleaseConfirmLbl:quickAddQuote.pleaseConfirmLbl}}" *ngIf="removeAllItemsConfirmationDialog"
                (close)="closeDeleteQuoteConfirmationBox()">
    <p style="margin: 30px; text-align: center;">
      {{quoteDetailTxt.deleteConfirmText2?quoteDetailTxt.deleteConfirmText2:quickAddQuote.deleteConfirmText2}}
    </p>
    <kendo-dialog-actions>
      <button class='k-button' (click)="closeDeleteQuoteConfirmationBox()">
        {{quoteDetailTxt.noLbl?quoteDetailTxt.noLbl:quickAddQuote.noLbl}}
      </button>
      <!--Have a spinner-->
      <button class='k-button k-primary' (click)="deleteAllQuoteItems()" primary="true">
        {{quoteDetailTxt.yesLbl?quoteDetailTxt.yesLbl:quickAddQuote.yesLbl}}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <!-- END DELETE QUOTE DIALOG POPUP -->
  <kendo-dialog *ngIf="infoOpened" (close)="closeInfoBox()">
    <div style="text-align: center;">
      <div class='contentKKItem'>
        <div class="k-display-flex justify-content-between float-right">
          <span class="k-icon k-i-close" (click)="closeInfoBox()"></span>
        </div>
        <div class='contentInfobox'>
          <div class="details">
            <img class="infoBoxImgKKItem" src="../../assets/images/Advance-Search/027010_S.gif" alt="product img">
          </div>
        </div>

      </div>
    </div>
  </kendo-dialog>
  <!-- This is for Item image-->
  <kendo-dialog *ngIf="showImageBox" (close)="closeImageModal()">
    <div style="text-align: center;">
      <div>
        <div class="k-display-flex justify-content-between float-right">
          <span class="k-icon k-i-close" (click)="closeImageModal()"></span>
        </div>
        <div>
          <strong>{{this.selectedItem.itemDescription}}</strong>
        </div>
        <div class='contentInfobox'>
          <div class="details">
            <img class="infoBoxImgKKItem a" imageLoader src='../../../assets/images/loading.svg' *ngIf="!selectedItem?.thumbnail" alt="product img">
            <span *ngIf="selectedItem?.thumbnail">
              <img class="infoBoxImgKKItem" imageLoader [src]='selectedItem?.thumbnail' *ngIf="selectedItem?.thumbnail" alt="product img">
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="selectedItem.itemType===2">
          <button kendoButton [icon]="'copy'" (click)="navigateToCopyConfigProduct(selectedItem)" class="m-3 blackBtn">
            {{quoteDetailTxt.copyLbl?quoteDetailTxt.copyLbl:quickAddQuote.copyLbl}}
          </button>
          <button kendoButton [icon]="'edit'" (click)="navigateToEditConfigProduct(selectedItem)" class="m-3 blackBtn">
            {{quoteDetailTxt.editLbl?quoteDetailTxt.editLbl:quickAddQuote.editLbl}}
          </button>
        </div>
      </div>
    </div>
  </kendo-dialog>

</section>
<Section class="dialogSection">
  <kendo-dialog title="Copy Quote" *ngIf="copyQuoteDialog.opened"
                (close)="toggleCopyQuoteDialog()">
    <div class="container-fluid">
      <form [formGroup]="copyQuoteForm" autocomplete="off">

        <div class="form-row">
          <div class="form-group col-md-12">
            <label>
              {{quoteDetailTxt.jobNameLbl?quoteDetailTxt.jobNameLbl:quickAddQuote.jobNameLbl}}<span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox class="kendoInput" name="jobName"
                   (blur)="validateAddQuoteForm()"
                   formControlName="jobName"
                   [ngClass]="{'borderRed':copyQuoteDialog.isInvalidJobName && copyQuoteDialog.isSubmitted}" />
          </div>
          <div class="form-group col-md-12">
            <label>
              {{quoteDetailTxt.marketSegmentLbl?quoteDetailTxt.marketSegmentLbl:quickAddQuote.marketSegmentLbl}}<span class="requiredField">*</span>
            </label>
            <kendo-dropdownlist [data]="getMarketSegment" formControlName="marketSegment"
                                (blur)="validateAddQuoteForm()"
                                textField="name" valueField="value" class="kendoInput"
                                [ngClass]="{'borderRed':copyQuoteDialog.isInvalidManageSegment && copyQuoteDialog.isSubmitted}">
            </kendo-dropdownlist>

          </div>
          <div class="form-group col-md-12">
            <label class="leedLbl">{{quoteDetailTxt.leedLbl?quoteDetailTxt.leedLbl:quickAddQuote.leedLbl}} </label>
            <kendo-switch formControlName="leed" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="leedSwitchCls">
            </kendo-switch>
          </div>

        </div>
        <div class="row">
          <div class="col-sm-6 msgInfoText">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
          <div class="col-sm-6">
            <div class="btn-group float-right" role="group">
              <button (click)="toggleCopyQuoteDialog()" class=" m-3 btn k-button dialogBtnSize" kendoButton>
                {{quoteDetailTxt.closeLbl?quoteDetailTxt.closeLbl:quickAddQuote.closeLbl}}
              </button>
              <button (click)="saveCopyQuoteData()" class="m-3 btn btn-success dialogBtnSize" kendoButton
                      [disabled]="saveInProcess">
                {{quoteDetailTxt.saveLbl?quoteDetailTxt.saveLbl:quickAddQuote.saveLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>

            </div>
          </div>
        </div>

      </form>
    </div>
  </kendo-dialog>

  <!--If No File Selected Confirmation Window started-->
  <kendo-dialog title="Alert"
                *ngIf="existingQuoteItemInCartAlertBox"
                (close)="closeQuoteItemInCartAlertBox(false)"
                [minWidth]="250"
                [width]="450">
    <p style="margin: 30px; text-align: center;">
      {{alertMessage}}
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeQuoteItemInCartAlertBox(true)" primary="true">Ok</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</Section>


<Section class="dialogSection">
  <kendo-dialog title="Express Checkout" *ngIf="showCheckoutModal"
                [width]="'70%'"
                [height]="'80%'"
                (close)="closeExpressCheckoutModal()">
    
    <div class="container-fluid">
      <!--<form [formGroup]="expressCheckoutForm" autocomplete="off">-->
      <div class="row" style="font-size:medium;font-weight:bold;margin-bottom:10px;font-size:20px;">
        <div class="col-md-7">
          Express Checkout for {{headerJobNumber}} {{orderdetail.jobName}}
        </div>
        <div class="col-md-5 checkout" style="text-align:end">
          <div *ngIf="!freightEstimateFlag">{{headerOrderTotal | currency}} - Total Price</div>
          <div *ngIf="freightEstimateFlag">
            <span style="font-weight:normal">
              Item Total:<b>{{headerOrderTotal | currency}}</b>
            </span>
            <br />

            <div *ngIf="showMinOrderFee" class="ec-inline-note">
              {{ minFeeDisplayLine }}
              <br />
            </div>
            <div *ngIf="totalPromoCredit < 0 ||  this.promofreefreight =='P' || this.promofreefreight =='CPT' " class="ec-inline-note">

              <span class="promo-remove-btn"
                    (click)="removePromoCodes()">
                ✕
              </span> 
<!--
              <span class="promo-help-icon"
                    title="Please select 'X' to remove Credit">
                ?
              </span>-->

              <span class="promo-credit-text">
                Promo:  {{ totalPromoCredit | currency }}
              </span>

              <br />
            </div>
            <!--<div *ngIf="totalPromoCredit > 0" class="ec-inline-note">
              Credit: - {{ totalPromoCredit | currency }}
              <br />
            </div>-->
            <span style="font-weight:normal">
              Shipping:
              <b>{{this.checkoutService.prepaidFreightSelected ? (displayShippingAmount | currency) : 'TBD'}}</b>
            </span>
            <br />

            <span style="font-weight:normal">
              Order Total:
              <b>{{this.checkoutService.prepaidFreightSelected ? (headerOrderTotal + displayShippingAmount + topMinOrderFeeValue + totalPromoCredit | currency) : 'TBD'}}</b>
            </span>
            <br />

            <!-- Promo Code Section -->
            <div style="margin-top:10px;">
              <div class="promo-row">

                <span class="promo-label">Promo Code:</span>

                <input type="text"
                       class="form-control promo-input"
                       placeholder="Enter Promo Code"
                       [(ngModel)]="promoCode">

                <button type="button"
                        class="btn btn-secondary promo-btn"
                        [disabled]="!promoCode || !promoCode.trim()"
                        (click)="applyPromoCode()">
                  Apply
                </button>

              </div>

              <div *ngIf="promoMessage"
                   [style.color]="promoMessageColor"
                   class="promo-message">
                {{ promoMessage }}
              </div>
            </div>
          </div>
          <!--<span>{{expressCheckoutControlTexts.totalPriceLabel?expressCheckoutControlTexts.totalPriceLabel:'Total Price'}}: {{headerOrderTotal | currency}}</span>-->
        </div>
      </div>
    </div>
    <div class="row"><div class="col-md-12 col-sm-12"><hr /></div></div>
    <div class="row" style="margin-top:10px;">
      <div class="col-md-4">
        <div>
          <strong>{{customerAddressLine1}}</strong><br />
          {{customerAddressLine2}}<br />
          {{customerAddressLine3}}
          <button kendoButton
                  style="background-color:white;border:none;"
                  (click)="showAddressSearchSection()">
            Change
          </button>
        </div>
        &nbsp;
        <div *ngIf="showAddressSearch">
          <div>
            <input type="search"
                   placeholder="Please enter name or zipcode"
                   style="width:70%"
                   class="k-textbox"
                   [(ngModel)]="addressSearchString"
                   maxlength="30" />
            <div class="searchIcon" (click)="searchAddress()">
              <span class="k-icon k-i-search"></span>
            </div>
          </div>
          &nbsp;
          <div *ngIf="shouldShowMaxShipToSearchHelpText">
            Showing top {{maxShipToResultCount}} result. More results available. Please refine your search to get the correct address...
          </div>
          <div *ngFor="let shipTo of suggestedAddressList" style="border:1px dashed;border-radius:5px;">
            <div style="display:inline-block; margin-top:5px;padding:5px;">
              <input type="radio"
                     name="addressSuggestion"
                     (change)="changeShippingAddress(shipTo.customerNumber)" />
              <strong>{{shipTo.customerNumber}} - {{shipTo.customerName}}</strong><br />
              {{shipTo.addressLine1}} {{shipTo.addressLine2}}<br />
              {{shipTo.city}}, {{shipTo.state}} {{shipTo.zipCode}}<br />
            </div>
          </div>
        </div>
      </div>
      <div>

      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label class="lbl" [for]="jobNameLBL">{{expressCheckoutControlTexts.jobNameLbl?expressCheckoutControlTexts.jobNameLbl:orderdetailsLbl.jobNameLbl}}<span class="requiredField">*</span> </label>
              <input type="search" kendoTextBox id="jobNameId"
                     [(ngModel)]="orderdetail.jobName" #jobNameLBL
                     (ngModelChange)="onJobNameChange($event)"
                     (blur)="validateCheckoutDetails()"
                     [ngClass]="{warningErrorBorder : orderDetailsForm?.isInvalidJobName && orderDetailsForm?.isSubmitted }"
                     class="kendoInput" [maxlength]="30"
                     tabindex="1"
                     (search)="jobSearchIconClick()"
                     (input)="onJobNameInput($event)" />
              <!--<div class="searchIcon" (click)="toggleJobSearchSection()">
                <span class="k-icon k-i-search"></span>
              </div>-->
            </div>
            <div class="form-group">
              <label class="lbl" [for]="jobCityLBL">{{expressCheckoutControlTexts.jobCityLbl?expressCheckoutControlTexts.jobCityLbl:orderdetailsLbl.jobCityLbl}}<span class="requiredField">*</span> </label>
              <input kendoTextBox [(ngModel)]="orderdetail.jobCity"
                     #jobCityLBL
                     (blur)="validateCheckoutDetails()"
                     class="kendoInput"
                     [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidJobCity && orderDetailsForm.isSubmitted }"
                     [maxlength]="25"
                     tabindex="2"
                     [disabled]="jobCityDisabled" />
            </div>
            <div class="form-group">
              <label class="lbl" [for]="jobStateLBL">{{expressCheckoutControlTexts.jobStateLbl?expressCheckoutControlTexts.jobStateLbl:orderdetailsLbl.jobStateLbl}}<span class="requiredField">*</span> </label>
              <kendo-dropdownlist class="kendoInput" #jobStateLBL
                                  [(ngModel)]="orderdetail.jobState"
                                  [data]="stateList"
                                  (valueChange)="validateCheckoutDetails()"
                                  [filterable]="true"
                                  textField="stateDescription"
                                  valueField="stateDescription"
                                  [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidJobState && orderDetailsForm.isSubmitted }"
                                  tabindex="3"
                                  (filterChange)="handleStatesFilterChange($event)">
              </kendo-dropdownlist>
            </div>
            <div class="form-group">
              <label class="lbl" [for]="poLBL">{{expressCheckoutControlTexts.poLbl?expressCheckoutControlTexts.poLbl:orderdetailsLbl.poLbl}}<span class="requiredField">*</span> </label>
              <input kendoTextBox [(ngModel)]="orderdetail.po"
                     #poLBL (blur)="validateCheckoutDetails()"
                     (ngModelChange)="onPoNameChange($event)"
                     class="kendoInput"
                     [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidPO && orderDetailsForm.isSubmitted }"
                     maxlength="30"
                     tabindex="4"
                     (input)="onPoInput($event)" />
            </div>
            <div class="form-group">
              <label class="lbl" [for]="marketSegmentLBL">{{expressCheckoutControlTexts.marketSegmentLbl?expressCheckoutControlTexts.marketSegmentLbl:orderdetailsLbl.marketSegmentLbl}}<span class="requiredField">*</span> </label>
              <kendo-dropdownlist class="kendoInput" #marketSegmentLBL
                                  [(ngModel)]="orderdetail.marketSegment"
                                  [data]="marketSegments"
                                  (valueChange)="validateCheckoutDetails()"
                                  textField="name"
                                  valueField="value"
                                  [filterable]='false'
                                  [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidMarketSegment && orderDetailsForm.isSubmitted }"
                                  tabindex="5">
              </kendo-dropdownlist>
            </div>
            <div *ngIf="freightEstimateFlag" class="form-group"
                 [ngClass]="{warningErrorBorder : orderDetailsForm.isFreightCalcIncomplete && orderDetailsForm.isSubmitted }">
              <label class="lbl" [for]="frieghtTermsLBL">{{expressCheckoutControlTexts.frieghtTermsLbl?expressCheckoutControlTexts.frieghtTermsLbl:orderdetailsLbl.frieghtTermsLbl}}<span class="requiredField">*</span> </label>
              <kendo-dropdownlist class="kendoInput" #frieghtTermsLBL
                                  [(ngModel)]="orderdetail.freightTerms" [popupSettings]="{popupClass:'freight-popup'}"
                                  [data]="getFreightTerms$ | async"
                                  (valueChange)="selectFreightTerms($event)"
                                  textField="name"
                                  valueField="value"
                                  [filterable]='false'
                                  [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightTerms && orderDetailsForm.isSubmitted }"
                                  tabindex="6">
              </kendo-dropdownlist>
            </div>
            <div [ngClass]="form-group" *ngIf="this.freightTermSelection ==2">
              <label class="lbl" [for]="frightNotesLBL">{{expressCheckoutControlTexts.frightNotesLbl?expressCheckoutControlTexts.frightNotesLbl:orderdetailsLbl.frightNotesLbl}}<span class="requiredField">*</span></label>
              <input kendoTextBox [(ngModel)]="orderdetail.freightNotes" #frightNotesLBL (blur)="validateCheckoutDetails()"
                     [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightNotes && orderDetailsForm.isSubmitted }"
                     class="kendoInput" [maxlength]="30" tabindex="17" />
            </div>
            <div *ngIf="this.freightTermSelection ==1" [ngClass]="(orderdetail.taxable == 'DEFAULT' || orderdetail.taxable == 'YES'?'form-group LeftCls topCls':'form-group LeftCls topCls1')">
              <kendo-switch [(ngModel)]="this.checkoutService.prepaidFreightSelected" #includeFreightLbl (valueChange)="SwitchFrieghtInclude($event)" [onLabel]="'Yes'" [offLabel]="'No'"
                            tabindex="16"></kendo-switch>
              <label class="lblPad" style="margin-left: 5px;" [for]="includeFreightLBL">{{expressCheckoutControlTexts.includeFreightLbl?expressCheckoutControlTexts.includeFreightLbl:orderdetailsLbl.includeFreightLbl}}</label>
              <span title="{{expressCheckoutControlTexts.includeFreightTitlelbl?expressCheckoutControlTexts.includeFreightTitlelbl:orderdetailsLbl.includeFreightTitlelbl}}"
                    class="k-icon k-i-information k-i-info spanInfoIconCls" kendoTooltip
                    style="color:black;font-weight:600;margin-left:5px;"></span>
              <kendo-loader *ngIf="this.checkoutService.freightCalcInProgress" style="color:blue"></kendo-loader>
              <!--*Retry If Applicable-->
              <button [icon]="'refresh'" *ngIf="this.freightTermSelection ==1 && this.checkoutService.prepaidFreightSelected && isRetry && !freightCalcInProgress" (click)="selectfrieghtTerms(4)" class="btn-success" kendoButton>
                Retry
              </button>
              &nbsp;&nbsp;&nbsp;
              <span *ngIf="this.freightTermSelection ==1 && this.checkoutService.prepaidFreightSelected && !freightCalcInProgress">${{this.checkoutService.checkOutProcessModel.freightAmount}}</span>
              <span style="color:red;" *ngIf="isFreightTermsError">{{isFreightTermsErrorMsg}}, you can select <b>PrePaid</b>,<b>Collect</b> or <b>Pickup</b> as an alternative option.</span>

            </div>
            <div class="form-group" *ngIf="!freightEstimateFlag">
              <label class="lbl" [for]="frieghtTermsLBL">{{expressCheckoutControlTexts.frieghtTermsLbl?expressCheckoutControlTexts.frieghtTermsLbl:orderdetailsLbl.frieghtTermsLbl}}<span class="requiredField">*</span> </label>
              <kendo-dropdownlist class="kendoInput" #frieghtTermsLBL
                                  [(ngModel)]="orderdetail.freightTerms"
                                  [data]="getFreightTerms$ | async"
                                  (valueChange)="validateCheckoutDetails()"
                                  textField="name"
                                  valueField="value"
                                  [filterable]='false'
                                  [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightTerms && orderDetailsForm.isSubmitted }"
                                  tabindex="7">
              </kendo-dropdownlist>

            </div>
            <div class="form-group">
              <label class="lbl" [for]="requestDateLBL">{{expressCheckoutControlTexts.requestDateLbl?expressCheckoutControlTexts.requestDateLbl:orderdetailsLbl.requestDateLbl}} </label>
              <kendo-datepicker class="kendoInput" [(ngModel)]="orderdetail.requestDate"
                                placeholder="MM/DD/YYYY"
                                #requestDateLBL format="MM/dd/yyyy"
                                [min]="minRequestDate"
                                [max]="maxRequestDate"
                                (focusout)="checkRequestDate()"
                                (blur)="checkRequestDateType()"
                                (keydown)="onDateKeyDown($event)"
                                [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidRequestDate && orderDetailsForm.isSubmitted }"
                                [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}" tabindex="8">
              </kendo-datepicker>
            </div>
            <div class="form-group">
              <label class="lbl" [for]="requestDateTypeLbl">{{expressCheckoutControlTexts.requestDateTypeLbl?expressCheckoutControlTexts.requestDateTypeLbl:orderdetailsLbl.requestDateTypeLbl}}
              <span *ngIf="!isRequestTypeDisable" class="requiredField">*</span></label>
              <kendo-dropdownlist #requestDateTypeDropdown [data]="RequestDateTypeDropdwon"
                                  [textField]="'name'" [valueField]="'value'"
                                  (selectionChange)="requestDateTypeChange($event)"
                                  [ngStyle]="isRequestTypeDisable==true ? {'pointer-events': 'none','opacity': '0.6'} : {}"
                                  [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidRequestDateType && orderDetailsForm.isSubmitted }"
                                  [ngModel]="{name:selectedRequestDateType,value:selectedRequestDateTypeval}" class="kendoInput"
                                   tabindex="9">
              </kendo-dropdownlist>
            </div>
            <div class="form-group">
              <label class="lbl" [for]="shipCompleteLbl">{{expressCheckoutControlTexts.shipCompleteLbl?expressCheckoutControlTexts.shipCompleteLbl:orderdetailsLbl.shipCompleteLbl}}</label>
              <kendo-dropdownlist [data]="shipCompleteDropdwon"
                                  [textField]="'name'" [valueField]="'value'"
                                  (selectionChange)="shipCompleteChange($event)"
                                  [ngModel]="{name:shipCompleteType,value:shipCompleteTypeval}" class="kendoInput"
                                   tabindex="10">
              </kendo-dropdownlist>
            </div>
            <div class="form-group">
              <label class="lbl" [for]="confirmEmailLbl">{{expressCheckoutControlTexts.confirmEmailLbl?expressCheckoutControlTexts.confirmEmailLbl:orderdetailsLbl.confirmEmailLbl}} </label>
              <kendo-multiselect [data]="sizes" [value]="selectedSizes" [(ngModel)]="orderdetail.confirmEmail"
                                 [allowCustom]="true" no-data-template="false" tabindex="11" [popupSettings]="{ height: dynamicHeight }"
                                 [listHeight]="dynamicHeight" (valueChange)="checkConfirmEmail($event)" [ngClass]="{'borderRed':isEmailFormatInvalid}">
                <ng-template kendoMultiSelectNoDataTemplate hidden let-dataItem>
                </ng-template>
              </kendo-multiselect>
              <span title="{{expressCheckoutControlTexts.invalidConfirmEmail?expressCheckoutControlTexts.invalidConfirmEmail:orderdetailsLbl.invalidConfirmEmail}}" *ngIf="isEmailFormatInvalid" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>
          </div>
            <div class="col-sm-12 col-md-6 rightSideDiv">
              <div class="form-group LeftCls">
                <input type="checkbox" class="k-checkbox checkboxSize" id="leed" (change)="selectLeed()"  [(ngModel)]="orderdetail.leed" tabindex="12" />
                <label class="lblPad" [for]="leed">{{expressCheckoutControlTexts.leedLbl?expressCheckoutControlTexts.leedLbl:orderdetailsLbl.leedLbl}} </label>
              </div>
              <!--<div class="form-group taxableCls LeftCls">
    <span #taxableInfo>
      <kendo-dropdownlist class="kendoInput" #taxableLBL
                          [defaultItem]="defaultTaxItem"
                          [data]="taxableDropdownData"
                          textField="text"
                          valueField="value"
                          [filterable]='false'
                          (valueChange)="taxableChange($event)"
                          tabindex="10" style="width: 150px;">
        >
      </kendo-dropdownlist>
      <span class="lblPad">
        <label class="lbl" [for]="taxableLBL" style="padding-right:5px;">{{expressCheckoutControlTexts.taxableLbl?expressCheckoutControlTexts.taxableLbl:orderdetailsLbl.taxableLbl}} </label>
        <span *ngIf="orderdetail.taxable == 'NO'">&nbsp;</span>
        <span *ngIf="orderdetail.taxable == 'NO'" class="k-icon k-i-info" (click)="taxableInfoToggle()" title="{{inputTax}}"></span>
        <kendo-popup #popup [anchor]="taxableInfo" *ngIf="taxHelpInfo"
                     (anchorViewportLeave)="taxHelpInfo = false">
          <span class="popupCss">
            {{inputTax}}
          </span>
        </kendo-popup>
      </span>
    </span>
  </div>
  <div class="form-group">
    <input kendoTextBox [(ngModel)]="orderdetail.taxableCertification"
           placeholder="{{expressCheckoutControlTexts.taxableCertificationLbl?expressCheckoutControlTexts.taxableCertificationLbl:orderdetailsLbl.taxableCertificationLbl}}" class="kendoInput bottomMargin"
           [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidTaxableCertification && orderDetailsForm.isSubmitted }"
           *ngIf="orderdetail.taxable == 'NO'" tabindex="11">
  </div>
  <div class="form-group uploadCls">
    <app-upload [multiple]="false" (fileSelect)="fileSelected($event)" [uploadFolderPath]="'TempDocs\\TaxDoc'" *ngIf="orderdetail.taxable == 'NO'" tabindex="12"
                (uploadSuccess)="uploadSuccess($event)" (uploadComplete)="uploadComplete()" [fileRestrictions]="fileRestrictions" [myFiles]="taxFiles"
                (uploadRemove)="uploadRemove($event)"></app-upload>
  </div> -->
              <div class="form-group LeftCls" style="min-width:250px;">
                <button (click)="toggletaxCertificatesDialog()" class="btn-success" kendoButton>
                  {{expressCheckoutControlTexts.taxablebuttonlbl?expressCheckoutControlTexts.taxablebuttonlbl:orderdetailsLbl.taxablebuttonlbl}}
                </button>
                <span title="{{expressCheckoutControlTexts.taxabletitlelbl?expressCheckoutControlTexts.taxabletitlelbl:orderdetailsLbl.taxabletitlelbl}}"
                      class="k-icon k-i-information k-i-info spanInfoIconCls" kendoTooltip
                      style="color:black;font-weight:600"></span>
              </div>
              <div [ngClass]="(orderdetail.taxable == 'DEFAULT' || orderdetail.taxable == 'YES'?'form-group LeftCls topCls':'form-group LeftCls topCls1')">
                <kendo-switch [(ngModel)]="orderdetail.quotedInHouse" #quotedInHouseLBL [onLabel]="'Yes'" [offLabel]="'No'"
                              tabindex="13"></kendo-switch>
                <label class="lblPad" [for]="quotedInHouseLBL">{{expressCheckoutControlTexts.quotedInHouseLbl?expressCheckoutControlTexts.quotedInHouseLbl:orderdetailsLbl.quotedInHouseLbl}}</label>
              </div>
              <div [ngClass]="(orderdetail.taxable == 'DEFAULT' || orderdetail.taxable == 'YES'?'form-group topCls':'form-group topCls1')"
                   *ngIf="orderdetail.quotedInHouse">
                <input kendoTextBox [(ngModel)]="orderdetail.quoteNumber"
                       [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidQuoteNumber && orderDetailsForm.isSubmitted }"
                       placeholder="{{quoteNumberLbl}}" class="kendoInput"
                       [maxlength]="30" tabindex="14" />
              </div>

            <div *ngIf="!freightEstimateFlag" [ngClass]="(orderdetail.quotedInHouse===true?'form-group':'form-group freightNoteCls')">
              <label class="lbl" [for]="frightNotesLBL">{{expressCheckoutControlTexts.frightNotesLbl?expressCheckoutControlTexts.frightNotesLbl:orderdetailsLbl.frightNotesLbl}} </label>
              <input kendoTextBox [(ngModel)]="orderdetail.freightNotes" #frightNotesLBL
                     [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightNotes && orderDetailsForm.isSubmitted }"
                     class="kendoInput" [maxlength]="30" tabindex="15" />
            </div>
            <div class="form-group">
              <label class="lbl" [for]="commentsLBL">{{expressCheckoutControlTexts.commentsLbl1?expressCheckoutControlTexts.commentsLbl1:orderdetailsLbl.commentsLbl1}} </label>
              <textarea kendoTextArea #commentsLBL class="kendoInput textArea" [maxlength]="maxChars"
                        [(ngModel)]="orderdetail.comments" (keyup)="commenttxtArea($event)"
                        [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidComments && orderDetailsForm.isSubmitted }"
                        placeholder="{{expressCheckoutControlTexts.commentsLbl2?expressCheckoutControlTexts.commentsLbl2:orderdetailsLbl.commentsLbl2}}" tabindex="16"></textarea>
              <div class="LeftCls"> {{expressCheckoutControlTexts.characterRemainingLbl?expressCheckoutControlTexts.characterRemainingLbl:orderdetailsLbl.characterRemainingLbl}}: {{commentslength}}/{{maxChars}}</div>
            </div>
          </div>
          &nbsp;
          <div class=" col-sm-12 col-lg-12 col-md-12" id="hiddentoModifyCreditLbl"
               *ngIf="!(checkOutCConlyCustomer || checkOutCCCustomer)">
            <div class="creditInformationDiv">
              <!--<div class="creditHeader">{{expressCheckoutControlTexts.defaultCreditInfoLbl?expressCheckoutControlTexts.defaultCreditInfoLbl:creditInfoLabel.defaultCreditInfoLbl}}</div>-->
              <div class="creditSubHeader" id="hiddentoModifyCreditLbl">{{expressCheckoutControlTexts.toModifyCreditLbl?expressCheckoutControlTexts.toModifyCreditLbl:creditInfoLabel.toModifyCreditLbl}}</div>
              <div class="row" id="hiddentoModifyCreditLbl">
                <div class="col-sm-6 paddingLeftZero">
                  <div class="row creditLeftCls">
                    <div class="col-12 paddingLeftZero">
                      <span>{{expressCheckoutControlTexts.payByCreditLbl?expressCheckoutControlTexts.payByCreditLbl:creditInfoLabel.payByCreditLbl}}</span>&nbsp;
                      <kendo-switch [(ngModel)]="orderdetail.useCreditCard" [onLabel]="'Yes'" [offLabel]="'No'"
                                    (click)="useCreditCard(orderdetail.useCreditCard)">
                      </kendo-switch>
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="row" *ngIf="showCreditCardDetails">
                <div class="col-12 paddingLeftZero">
                  <div class="row creditLeftCls">
                    <div class="col-12 paddingLeftZero">
                      <span>{{expressCheckoutControlTexts.cardTypeLbl?expressCheckoutControlTexts.cardTypeLbl:creditInfoLabel.cardTypeLbl}}</span>&nbsp;
                      <span>{{creditInfoLabel.cardTypeText}}</span>
                    </div>
                    <div class="col-12 paddingLeftZero">
                      <span>{{expressCheckoutControlTexts.nameOnCardLbl?expressCheckoutControlTexts.nameOnCardLbl:creditInfoLabel.nameOnCardLbl}}</span>&nbsp;
                      <span>{{creditInfoLabel.nameOnCardText}}</span>
                    </div>
                    <div class="col-12 paddingLeftZero">
                      <span>{{expressCheckoutControlTexts.creditCardNumberLbl?expressCheckoutControlTexts.creditCardNumberLbl:creditInfoLabel.creditCardNumberLbl}}</span>&nbsp;
                      <span>{{creditInfoLabel.cardNumberText}}</span>
                    </div>
                    <div class="col-12 paddingLeftZero">
                      <span>{{expressCheckoutControlTexts.cardExpiryLbl?expressCheckoutControlTexts.cardExpiryLbl:creditInfoLabel.cardExpiryLbl}}</span>&nbsp;
                      <span>{{creditInfoLabel.expirationMonth}}/{{creditInfoLabel.expirationYear}}</span>
                    </div>

                  </div>

                </div>
              </div>-->
            </div>
          </div>

        </div>
        <div class="row" *ngIf="freightEstimateNoteFlag && this.checkoutService.prepaidFreightSelected">
          <div class="col-sm-12 col-md-12">
            {{shippingDevNote}}
          </div>
        </div>
      </div>
    </div>


    <!--</form>-->
    <div class="checkout-status-parent">
      <!--<div *ngIf="checkoutInProgress|| true" class="checkout-status-child">
        In Progress...
        <kendo-loader style="color:blue">
      </div>-->
      <div *ngIf="checkoutSuccess" class="checkout-status-child">
        <div style="text-align: center;">
          <span class="k-icon k-i-check-outline k-i-checkmark-outline k-i-success"
                style="font-size: 50px !important; color: green"></span>
          <p>{{lblText.submitedInfo1?lblText.submitedInfo1:checkOut.submitedInfo1}}</p>
          <h4>{{lblText.submitedInfo2?lblText.submitedInfo2:checkOut.submitedInfo2}}</h4>
          <p>
            {{lblText.kawneerOrderLbl?lblText.kawneerOrderLbl:checkOut.kawneerOrderLbl}}:  #{{lblText.kdLbl?lblText.kdLbl:checkOut.kdLbl}}{{kdRefNumber}}.
          </p>

        </div>
      </div>
      <div *ngIf="checkoutError" class="checkout-status-child">
        <div style="text-align: center;">
          <span class="k-icon k-i-close-outline k-i-x-outline k-i-error"
                style="font-size:50px!important;color:red"></span>
          <h4>{{lblText.submitedInfo3?lblText.submitedInfo3:checkOut.submitedInfo3}}</h4>
          <p>{{lblText.submitedInfo4?lblText.submitedInfo4:checkOut.submitedInfo4}}</p>
          <p>
            <!--<button kendoButton primary="true" style="width: 300px;" (click)="closeConfirmDialog()">{{lblText.closeLbl?lblText.closeLbl:checkOut.closeLbl}}</button>-->
          </p>
        </div>

      </div>

    </div>

    <!--</div>-->

    <kendo-dialog-actions>
      <div style="margin-right:auto; margin-left: auto">
        <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" *ngIf="hasPlaceOrderAccess && !checkoutSuccess">
          <button kendoButton (click)="processCheckout()" *ngIf="!freightEstimateFlag" [disabled]="this.checkoutService.freightCalcInProgress" primary="true">
            {{lblText.confirmOrderLbl?lblText.confirmOrderLbl:checkOut.confirmOrderLbl}}
            <kendo-loader *ngIf="checkoutInProgress" style="color:blue"></kendo-loader>
          </button>
          <div *ngIf="freightEstimateFlag">
            <div *ngIf="!checkOutCCCustomer && !checkOutCConlyCustomer">
              <button kendoButton (click)="processCheckoutChargeToAccount()" [disabled]="checkoutInProgress || checkoutInProgressCC || this.checkoutService.freightCalcInProgress" primary="true">
                {{lblText.confirmOrderLbl?lblText.confirmOrderLbl:checkOut.confirmOrderLbl}}
                <kendo-loader *ngIf="checkoutInProgress" style="color:blue"></kendo-loader>
              </button>
            </div>
            <div *ngIf="checkOutCCCustomer || checkOutCConlyCustomer">
              <button kendoButton *ngIf="checkOutCCCustomer" (click)="processCheckoutChargeToAccount()" [disabled]="checkoutInProgress || checkoutInProgressCC || this.checkoutService.freightCalcInProgress" primary="true">
                {{lblText.placeOrderChangetoAccountLbl?lblText.placeOrderChangetoAccountLbl:checkOut.placeOrderChangetoAccountLbl}}
                <kendo-loader *ngIf="checkoutInProgress" style="color:blue"></kendo-loader>
              </button>
              &nbsp;&nbsp;&nbsp;
              <button kendoButton (click)="openPaymentWithCCDialog()" [disabled]="checkoutInProgress || checkoutInProgressCC || this.checkoutService.freightCalcInProgress" *ngIf="(checkOutCCCustomer || checkOutCConlyCustomer)" primary="true">
                {{lblText.placeOrderWithCreditCardLbl?lblText.placeOrderWithCreditCardLbl:checkOut.placeOrderWithCreditCardLbl}}
                <kendo-loader *ngIf="checkoutInProgressCC" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="checkoutSuccess">
          <div class="center-btn">
            <button kendoButton primary="true"
                    style="width: 300px; "
                    (click)="closeExpressCheckoutModal()">
              {{lblText.continueShoppingLbl?lblText.continueShoppingLbl:checkOut.continueShoppingLbl}}
            </button>
           &nbsp;
            <a style=" cursor: pointer; margin-top: 9px;" [routerLink]="['/survey']">
              {{lblText.surveyFeedbackLbl?lblText.surveyFeedbackLbl:checkOut.surveyFeedbackLbl}}
            </a>
          </div>
        
        </div>
      </div>


      <!--<button kendoButton (click)="closeExpressCheckoutModal(true)" primary="true">Close</button>-->
    </kendo-dialog-actions>
  </kendo-dialog>
</Section>
<section class="dialogsection">
  <!--KENDO POP UP FOR TAX CERTIFICATE SELECTION START-->
  <kendo-dialog title="{{expressCheckoutControlTexts.taxCertifiactetitletxt?expressCheckoutControlTexts.taxCertifiactetitletxt:orderdetailsLbl.taxCertifiactetitletxt}}"
                style="min-width:500px;" *ngIf="taxCertificatesDialog.opened" (close)="toggletaxCertificatesDialog()">
    <div style="max-width:500px;">
      <form class="k-form" [formGroup]="taxCertificateForm" style="padding: 0px ! important;">
        <div style="text-align:center"><b>{{expressCheckoutControlTexts.taxCertifiacteddlheadertxt?expressCheckoutControlTexts.taxCertifiacteddlheadertxt:orderdetailsLbl.taxCertifiacteddlheadertxt}}</b></div>
        <br />
        <kendo-dropdownlist class="txt-size"
                            [data]="filteredTaxCertificatesItems"
                            [textField]="'name'"
                            [filterable]="true"
                            [valueField]="'id'"
                            (selectionChange)="taxCertificateChangeSelected($event)"
                            (close)="onCloseCertificateChange($event)"
                            (filterChange)="handleTaxCertificateFilter($event)">
        </kendo-dropdownlist>

        <br />
        <span> {{expressCheckoutControlTexts.taxCertifiactenotelbl?expressCheckoutControlTexts.taxCertifiactenotelbl:orderdetailsLbl.taxCertifiactenotelbl}} </span>
        <br />
        <br />
        <div style="text-align:center">
          <button kendoButton class="btn-success"
                  (click)="addCertificatesCommentSubmit()" [disabled]="!taxCertificatesDialog.valid">
            {{expressCheckoutControlTexts.taxCertifiactebtntxt?expressCheckoutControlTexts.taxCertifiactebtntxt:orderdetailsLbl.taxCertifiactebtntxt}}
          </button>
          &nbsp;
          <button kendoButton (click)="toggletaxCertificatesDialog()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </kendo-dialog>
  <!--KENDO POP UP FOR TAX CERTIFICATE SELECTION END-->
</section>

<!-- This is for Import File -->
<app-import-item *ngIf="importDialog.opened" (importCompleteEvent)="importCompleteEvent($event)" [inputData]="importDialog"></app-import-item>


<!-- This is for snappay test section start-->
<section class="dialogsection">
  <kendo-dialog title="Payment"
                [width]="'70%'"
                [height]="'80%'"
                *ngIf="showPaymentDialog" (close)="cancelOrder()">
    <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row"
         style="text-align: center"
         *ngIf="paymentPortalInitializing">
      Please wait we are initializing.....
    </div>
    <iframe [src]="url" height="100%" width="100%"></iframe>
    <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row"
         style="text-align: center">
      <button kendoButton
              (click)="cancelOrder()"
              class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
        Cancel
      </button>
    </div>
  </kendo-dialog>
</section>
<!-- This is for snappay test section end-->
<!-- This is for credit card kendo-dialog section start-->
<section class="dialogsection">
  <kendo-dialog *ngIf="cCPaymentConfirmationDialog" (close)="ClosePaymentWithCCDialog()">
    <div><p style="text-align: center;"><u><b>You have chosen to Pay by Credit Card</b></u></p></div>
    <div *ngIf="this.orderdetail.freightTerms.value == 1 && !this.checkoutService.prepaidFreightSelected">
      <div><p style="text-align: center;color: red;"><b>Paying by Credit Card requires Freight Charges to be included.</b></p></div>
      <div><p style="text-align: center;color: red;"><b>Cancel and Return to Payment Options and select "Estimate & Include with Order".</b></p></div>
    </div>
    <div *ngIf="this.orderdetail.freightTerms.value == 2">
      <div><p style="text-align: center;">By proceeding, you acknowledge and agree to a 3% credit card surcharge based on the Order Total.</p></div>
      <div><p style="text-align: center;">The estimated surcharge for this order is {{this.creditCardCharge| currency}}</p></div>
      <div><p style="text-align: center;"><b>Your Estimated Order Total including surcharge is {{this.creditCardTotalAmount| currency}}</b></p></div>
      <div><p style="text-align: center;color:red;"><b>Note: Shipping costs may still be applicable for pickup orders depanding upon the products orginating location. If applicable, you will be notified of additional charges during Order Processing</b></p></div>
      <div><p style="text-align: center;">Your credit card will be authorized on the next screen and charged when material ships.</p></div>
    </div>
    <div *ngIf="(this.orderdetail.freightTerms.value == 1 && this.checkoutService.prepaidFreightSelected) ||  this.orderdetail.freightTerms.value == 3 ||  this.orderdetail.freightTerms.value == 4">
      <div><p style="text-align: center;">By proceeding, you acknowledge and agree to a 3% credit card surcharge based on the Order Total.</p></div>
      <div><p style="text-align: center;">The estimated surcharge for this order is {{this.creditCardCharge| currency}}</p></div>
      <div><p style="text-align: center;"><b>Your Estimated Order Total including surcharge is {{this.creditCardTotalAmount| currency}}</b></p></div>
      <div><p style="text-align: center;">Your credit card will be authorized on the next screen and charged when material ships.</p></div>
    </div>
    <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row"
         style="text-align: center">
      <button kendoButton
              (click)="processCheckoutCC()" *ngIf="this.orderdetail.freightTerms.value > 1 ||  (this.orderdetail.freightTerms.value == 1 && this.checkoutService.prepaidFreightSelected)"
              class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
        Accept Fee and Continue
      </button>
      <button kendoButton
              (click)="ClosePaymentWithCCDialog()"
              class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
        Cancel and Return to Payment Options
      </button>
    </div>
  </kendo-dialog>
</section>
<!-- This is for credit card kendo-dialog section start-->

<!-- <kendo-dialog *ngIf="this.quoteService.selectedQuoteHeader.isLocked" title="{{this.QuoteLockDialog.title}}" (close)="closeQuoteLockDialog()"
              class="kendoCartPopupCls">
  <div style="width: 100%;height: 100px; margin: 5px 0;">
    <div style="text-align: center;"><p style="text-align: center;">{{this.QuoteLockDialog.loadingMessage}}</p></div>
    <kendo-loader *ngIf="this.QuoteLockDialog.isLoad" style="color:red; margin-left:40%"></kendo-loader>
  </div>
</kendo-dialog>-->
